import { createSlice } from '@reduxjs/toolkit';
import { createAsyncAction } from '../action/index';

const getClinicSchedule = createAsyncAction('getClinicSchedule', 'getClinicSchedule');
const getShifts = createAsyncAction('getShifts', 'getShifts');
const addShift = createAsyncAction('addShift', 'addShift');
const editShift = createAsyncAction('editShift', 'editShift');
const deleteShift = createAsyncAction('deleteShift', 'deleteShift');
const updateShift = createAsyncAction('updateShift', 'updateShift');
const getNextAvailableSlot = createAsyncAction('getNextAvailableSlot', 'getNextAvailableSlot');
const getOnlineSchedule = createAsyncAction('getOnlineSchedule', 'getOnlineSchedule');

interface InitialState {
  shifts: any[],
  shiftByClinicId: any;
  nextAvailableSlotByClinicId: any;
  onlineScheduleByClinicId: any;
  isFetchingShifts: boolean,
  isFetchingShift: boolean,
  isFetchingNextAvailableSlot: boolean,
  isFetchingOnlineSchedule: boolean;
}

const initialState = {
  shifts: [],
  shiftByClinicId: {},
  nextAvailableSlotByClinicId: {},
  onlineScheduleByClinicId: {},
  isFetchingShifts: false,
  isFetchingShift: false,
  isFetchingNextAvailableSlot: false,
  isFetchingOnlineSchedule: false,
} as InitialState;

export const counterSlice = createSlice({
  name: 'shifts',
  initialState,
  reducers: {
    // resetOrderStatus(state) {
    //   state.orderStatus = '';
    // },
  },
  extraReducers: {
    [getShifts.pending as any]: (state) => {
      state.isFetchingShifts = true;
      state.shifts = [];
    },
    [getShifts.fulfilled as any]: (state, { payload, meta }) => {
      state.shifts = payload;
      const clinicID = meta?.arg?.clinicID;
      state.shiftByClinicId[clinicID] = payload || {};
      state.isFetchingShifts = false;
    },
    [getShifts.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingShifts = false;
    },
    [getNextAvailableSlot.pending as any]: (state) => {
      state.isFetchingNextAvailableSlot = true;
    },
    [getNextAvailableSlot.fulfilled as any]: (state, { payload, meta }) => {
      const clinicID = meta?.arg?.clinicID;
      state.nextAvailableSlotByClinicId[`${clinicID}`] = payload || {};
      state.isFetchingNextAvailableSlot = false;
    },
    [getNextAvailableSlot.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingNextAvailableSlot = false;
    },
    [getOnlineSchedule.pending as any]: (state) => {
      state.isFetchingOnlineSchedule = true;
    },
    [getOnlineSchedule.fulfilled as any]: (state, { payload, meta }) => {
      const clinicID = meta?.arg?.clinicID;
      state.onlineScheduleByClinicId[`${clinicID}`] = payload || {};
      state.isFetchingOnlineSchedule = false;
    },
    [getOnlineSchedule.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetchingOnlineSchedule = false;
    },
  },
});

export {
  getClinicSchedule,
  getShifts,
  addShift,
  editShift,
  deleteShift,
  updateShift,
  getNextAvailableSlot,
  getOnlineSchedule,
};
export default counterSlice.reducer;